// Corresponds to 10 frames at 60 Hz.

export function debounce<TFunc extends Function>(func: TFunc, wait = 166) {
  let timeout: NodeJS.Timeout
  function debounced<Args extends unknown[]>(...args: Args) {
    const later = () => {
      // @ts-expect-error hide `this`
      func.apply(this, args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
  debounced.clear = () => {
    clearTimeout(timeout)
  }
  return debounced
}
